import React, { useState, useEffect, Fragment } from 'react';
import styled from 'styled-components'
import { NavLink } from "react-router-dom";
import { Asset } from "@archetypes";
import { Panel, Grid, GateKeeper, Modal } from "@components"
import { ReactComponent as ArrowLeft } from '@assets/Icon_Arrow_Left.svg';
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';
import { ReactComponent as Info } from "@assets/Icon_Info_Large.svg"
import assetController from '@app/App.Controller'
import { parsePoolWeight, calculateAPY, fromWei } from "@util/helpers"
import useModal from "../../hooks/useModal"

const Stats = styled(
    ({ className,
        pool
    }) => {

        const { open, openModal, closeModal } = useModal()

        return (
            <>
                <Panel className={className}>
                    <div className="breadcrumb">
                        <NavLink to="/stake" >
                            <ArrowLeft className="svg" />
                            <div>
                                ALL POOLS
                        </div>
                        </NavLink>
                    </div>
                    <div className="body">
                        <div className="col">
                            <Asset.Icon.Dual
                                token={[pool?.token0?.symbol, pool?.token1?.symbol]}
                            />
                            <div className="pool-data">
                                <h4>
                                    {pool?.name}
                                </h4>
                                <p>
                                    {parsePoolWeight(pool)}
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="pool-stats">
                                {["Depth", "Volume", "Price"].map((item, index) => {
                                    let value = ""
                                    switch (index) {
                                        // case 0:
                                        //     value = `${calculateAPY(pool?.token1?.symbol)}%`
                                        //     break
                                        case 0:
                                            value = `$${Number(fromWei(pool?.depth.toFixed(0))).toLocaleString()}`
                                            break
                                        case 1:
                                            value = `$${Number(0).toLocaleString()}` // TODO: Fill-in volumes
                                            break
                                        case 2:
                                            value = `$${(pool?.token1?.dollarPrice).toLocaleString()}`
                                            break
                                    }
                                    return (
                                        <div key={index}>
                                            <h4>{item}</h4>
                                            <p>{value}</p>
                                        </div>
                                    )
                                })}
                                <div className="icon-wrapper">
                                    <Info onClick={openModal} className="icon-info" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Panel>
                {open ? (
                    <Modal.PoolInfo
                        close={closeModal}
                        pool={pool}
                    />
                ) : null}
            </>
        )
    })`

    display: flex;
    flex-direction: column;

    .nav-link {
        display: flex;
        flex-direction: row;
    }

    >.breadcrumb {
        padding-top: 1rem;
        padding-bottom: 1rem;
        font-size: 16px;
        font-weight: 600;
        a {
            cursor: pointer;
            display: flex;
            flex-direction: row;
        }
        
        .svg {
            height: 22px;
            width: 22px;
            margin-right: 1rem; 
        }

    }

    >.body {
        display: flex;
        flex-direction: row;
        padding-top: 2rem;
        padding-bottom: 2rem;
         .col {
            flex : 3;
            :first-child {
                flex : 2;
            }
            display: flex;
            flex-direction: row;

            .pool-data {
                display: flex;
                flex-direction: column;
                margin-left: 2rem;
                h4 {
                    margin: 0px;
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 600;
                    color: var(--color-white);
                }
                p {
                    margin: 0px;
                    color: var(--color-label);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 600;
                }
            }

            .pool-stats {
                display: flex;
                flex-direction: row; 
                flex-grow: 1;

                div {
                    flex: 1;
                }
                h4 {
                    margin: 0px;
                    color: var(--color-label);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 600;
                }
                p {
                    margin: 0px;
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 600;
                    color: var(--color-white);
                }
                .icon-wrapper {
                    display: flex;
                }
                .icon-info {
                    width: 32px;
                    height: 32px;
                    fill: var(--panel--background--color, grey);
                    cursor: pointer;
                    margin-top: auto;
                    margin-bottom: auto;
                }
            }

         }
    }

    `

export default ({ address }) => {

    const { perlinx } = assetController
    const [data, setData] = useState()

    useEffect(() => {
        const sub = perlinx.state.subscribe(`pools.${address}`, setData, true)
        return () => sub.unsubscribe()
    }, []) // eslint-disable-line

    return (
        <GateKeeper
            assertions={[
                {
                    assert: () => !!data,
                    onFail: () => <Panel><Refresh className='rotate' /></Panel>,
                }
            ]}
            dependencies={[data]}
        >
            <Stats
                pool={data}
            />
        </GateKeeper>
    )
}